(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["Framer"] = factory(require("react"));
	else
		root["Framer"] = factory(root["React"]);
})(globalThis, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 